/*
 * Sophestia PDP — Description "Read more" toggle.
 *
 * Generic: works for every product. Full body stays in DOM (SEO ✓);
 * collapsed visually via max-height. Toggle button injected as a sibling
 * after the .product__description element only when content overflows
 * the collapsed height.
 */
(function () {
  function init() {
    var descriptions = document.querySelectorAll('.product__description');
    descriptions.forEach(function (desc) {
      if (desc.dataset.sophestiaToggleInit === '1') return;
      desc.dataset.sophestiaToggleInit = '1';

      // If content fits within the collapsed max-height (≈140px),
      // no toggle needed -- mark as no-collapse and bail.
      var collapsedHeight = desc.clientHeight;
      if (desc.scrollHeight <= collapsedHeight + 4) {
        desc.classList.add('product__description--no-collapse');
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__description-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      desc.insertAdjacentElement('afterend', btn);

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        desc.classList.toggle('product__description--expanded');
        btn.textContent = expanded ? 'Read more' : 'Read less';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
